import labels from "./labels";

const MINUTES_PER_HOUR = 60;

/** Formats a number of minutes as e.g. "1 time 35 minutter", leaving out a zero part. */
export const formatMinutes = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
  const minutes = totalMinutes % MINUTES_PER_HOUR;
  if (hours === 0) return labels.minutesAmount(minutes);
  if (minutes === 0) return labels.hoursAmount(hours);
  return `${labels.hoursAmount(hours)} ${labels.minutesAmount(minutes)}`;
};

/** Like formatMinutes, but shows the sign of a non-zero value, e.g. "+7 timer" or "-30 minutter". */
export const formatSignedMinutes = (totalMinutes: number): string => {
  if (totalMinutes === 0) return formatMinutes(0);
  const sign = totalMinutes < 0 ? "-" : "+";
  return `${sign}${formatMinutes(Math.abs(totalMinutes))}`;
};
